<template>
  <FadeTransition>
    <KeepAlive>
      <component
        :is="step.component"
        :on-mfa-login-success="onMfaLoginSuccess"
        :info-mfa="infoMfa"
        :login-data="loginData"
        @next-step="handleNextStep"
        @previous-step="handlePreviousStep"
      />
    </KeepAlive>
  </FadeTransition>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  IMFAInfo,
  ILoginData,
  IMFALoginResponse
} from '@/modules/authentication/services/mfa';
import { MFALoginComponents } from './step-components';
import { EMFALoginSteps } from './types';
import { FadeTransition } from '@/modules/common/components/FadeTransition';

@Component({
  components: {
    FadeTransition
  }
})
export default class MFALogin extends Vue {
  @Prop({ type: Object, required: true })
  private infoMfa!: IMFAInfo;

  @Prop({ type: Function, default: () => {} })
  private onMfaLoginSuccess!: (data: IMFALoginResponse) => void;

  @Prop({ type: Object, required: true })
  private loginData!: ILoginData;

  private currentStep = EMFALoginSteps.MULTI_FACTOR_LOGIN;

  get step() {
    return {
      component: MFALoginComponents[this.currentStep]
    };
  }

  public handleNextStep(step?: string) {
    if (step === 'talkWarren') {
      this.currentStep = EMFALoginSteps.TALK_TO_WARREN;
    } else {
      this.currentStep++;
    }
  }

  public handlePreviousStep(step?: string) {
    if (step === 'disconnectDevices') {
      this.currentStep = EMFALoginSteps.DISCONNECT_DEVICES;
    } else {
      this.currentStep--;
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  @navbar-height: 64px;
  @footer-height: 150px;
  min-height: calc(100vh - (@navbar-height + @footer-height));
  display: flex;
  justify-content: center;
  align-items: center;

  .helper-view {
    width: 320px;
  }
}
</style>
